const category = 'PWA';

export const SegmentPWAEvent = {
    INSTALLED: { category, event: 'Installed' },
};
